@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (loadingInitConfig) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (loadingInitConfig) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (loadingInitConfig) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (loading) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<!-- <mat-toolbar class="mb-2">
<mat-icon mat-list-icon>supervisor_account</mat-icon>
<span class="container-fluid">
  <h1>Back Office 24</h1>
</span>
<span class="example-spacer"></span>
<button mat-mini-fab matTooltip="Home" (click)="sendMessage()">
  <mat-icon>home</mat-icon>
</button>
<button mat-mini-fab matTooltip="Search" (click)="sendMessage()">
  <mat-icon>category_search</mat-icon>
</button>
<button mat-mini-fab matTooltip="Search" (click)="sendMessage()">
  <mat-icon>search</mat-icon>
</button>
<button mat-mini-fab matTooltip="Dashboard" (click)="sendMessage()">
  <mat-icon>dashboard_2</mat-icon>
</button>
<button mat-mini-fab matTooltip="Fyrkantig" (click)="sendMessage()">
  <mat-icon *ngIf="cjHubService.getConnectionState() == 'Connected'" style="color:green">check_box_outline_blank</mat-icon>
  <mat-icon *ngIf="cjHubService.getConnectionState() != 'Connected'" style="color:red">check_box_outline_blank</mat-icon>
</button>
</mat-toolbar> -->

<mat-tab-group [(selectedIndex)]="demo1TabIndex" (selectedIndexChange)="setOrganizationId($event)">
  @for (organization of visibleOrganizations; track organization; let i = $index) {
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="example-tab-icon">home</mat-icon>
        {{organization.organizationName}}
      </ng-template>
      <div class="container-fluid my-2 p-0">
        @if (demo1TabIndex === i) {
          <app-back-office24-modules
          [organization]="organization"></app-back-office24-modules>
        }
      </div>
    </mat-tab>
  }

  @if (meTab) {
    <mat-tab #meTab>
      <ng-template mat-tab-label>
        <mat-icon class="example-tab-icon">diversity_1</mat-icon>
        Me
      </ng-template>
      @if (meTab.isActive) {
        <div class="container-fluid my-2">
          <div>Bookings: </div>
          <div class="bookings-button-group">
            <!-- <button mat-stroked-button (click)="selectOrg('flygets')">Flygets</button>
            <button mat-stroked-button (click)="selectOrg('skavsta')">Skavsta</button>
            <button mat-stroked-button (click)="selectOrg('mdpark')">MDPark</button> -->
            <button type="button" (click)="openDebug()" mat-stroked-button matTooltip="Debug">Debug mode</button>
          </div>
        </div>
      }
      @if (meTab.isActive) {
        <div class="container-fluid my-2">
          <div>Roles: {{authService.getRoleName()}}</div>
          <!-- <button mat-stroked-button
        (click)="refreshMyConfig()">refreshMyConfig({{myConfigService?.myConfig?.organizations.length}})</button> -->
        <button mat-stroked-button (click)="testOrganizations()">testOrganizations()</button>
        <button mat-stroked-button (click)="testUsers()">testUsers()</button>
        @for (organization of myConfigService?.myConfig?.organizations; track organization; let myIndex = $index) {
          <div class="org-item">
            <b><u>{{myIndex}} - {{organization.organizationName}} - Roles:
            {{organization.organizationMemberType}}</u></b>
            @for (module of organization?.config?.modules; track module; let myMenuIndex = $index) {
              <div>
                @if (canShowModule(module.name, organization)) {
                  <div class="module-access-allowed">Menu -
                    <b>{{myIndex}}.{{myMenuIndex}}: {{module.name}} - {{module.menu.name}} - {{module.roles}}</b>
                  </div>
                }
                @if (!canShowModule(module.name, organization)) {
                  <div>
                    @if (authService.isAdminOrSiteAdmin()) {
                      <div class="module-access-admin">
                        Menu - <i>{{myIndex}}.{{myMenuIndex}}: {{module.name}} - {{module.menu.name}} -
                      {{module.roles}}</i>
                    </div>
                  }
                  @if (!authService.isAdminOrSiteAdmin()) {
                    <div class="module-access-denied">
                      Menu - <i>{{myIndex}}.{{myMenuIndex}}: {{module.name}} - {{module.menu.name}} -
                    {{module.roles}}</i>
                  </div>
                }
              </div>
            }
          </div>
        }
        @for (module of organization.config.backOfficeModules; track module; let myMenuIndex = $index) {
          <div>
            <div>BackofficeModule - <b>{{myIndex}}.{{myMenuIndex}}.{{module.name}}:
            {{module.menu.name[activeLang]}}</b> -
          {{module.menu.description[activeLang]}}</div>
        </div>
      }
    </div>
  }
</div>
}
<div class="legend-section">
  <div><b><u>Organization and role</u></b></div>
  <div class="legend-allowed">Access by role and module</div>
  <div class="legend-admin">Access by admin or siteadmin </div>
  <div class="legend-denied">No access</div>
</div>
<div class="container-fluid my-4">
  @if (authService?.loggedIn()) {
    <mat-card appearance="outlined"
      class="text-container text-center mat-elevation-z8">
      <mat-card-header>
        <h2 class="welcome-text">
          {{'LOGIN.WELCOME' | transloco}}
        </h2>
      </mat-card-header>
      <mat-card-content>
        <div class="text-left">
          <b>Parkifly</b>
          <ul>
            <li><a href="/flygets/flygets-start" target="_blank">flygets.se</a> |
            <a href="/faq" target="_blank">faq</a> |
            <a href="/flygets/priser" target="_blank">/flygets/priser</a> |
            <a href="/flygets/hitta-hit" target="_blank">/flygets/hitta-hit</a> |
            <a href="/flygets/kontakta-oss" target="_blank">/flygets/kontakta-oss</a> |
            <a href="/self-service" target="_blank">/self-service</a> |
            <a href="/kund" target="_blank" class="strikethrough-link">/kund</a> |
            <a href="/Shuttlebuss/Shuttlebuss.Service/Ping/LprLog" target="_blank">/lprLog</a> |
            <a href="/checkout/payment/c67b4aa6-b9e1-494a-c6e7-08dd860f8821"
            target="_blank">/checkout/payment/...</a> |
            <a href="/nazar" target="_blank">Nasar</a> |
            <a href="/tui" target="_blank">TUI</a> |
            <a href="/parkifly/flygets" target="_blank">parkifly/flygets</a> |
            <a href="/parkifly/skavsta" target="_blank">parkifly/skavsta</a> |
            <a href="/parkifly/p2" target="_blank">parkifly/p2</a> |
            <a href="/parkifly/quality-xpo-arlanda-parkandfly"
            target="_blank">parkifly/quality-xpo-arlanda-parkandfly</a> |
            <a href="/parkifly/quality-xpo-arlanda" target="_blank">parkifly/quality-xpo-arlanda</a> |
            <a href="/parkifly/quality-landing-page" target="_blank">parkifly/quality-landing-page</a> |
            <a href="/parkifly/aiden-landing-page" target="_blank">parkifly/aiden-landing-page</a> |
            <a href="/parkifly/handle-booking" target="_blank">parkifly/handle-booking</a>
          </li>
        </ul><br>
        <b>Shuttles</b>
        <ul>
          <li>
            <a href="/booking-service/5BF79F25-27BF-4B5B-AF83-B4A0233DAB70" target="_blank">Apart</a> |
            <a href="/booking-service/5BF79F25-27BF-4B5B-AF83-B4A0233DAB70" target="_blank">Apart Direkt</a> |
            <a href="/booking-service/417596F5-8FE5-4FA7-84DC-0AF0ACE72CF1" target="_blank">Scandic</a> |
            <a href="/booking-service/417596F5-8FE5-4FA7-84DC-0AF0ACE72CF1" target="_blank">Scandic Direkt</a> |
            <a href="/booking-service/39218780-069A-4C6B-9925-22365A075C15" target="_blank">Quality Hotel Arlanda
            XPO</a> |
            <a href="/booking-service/39218780-069A-4C6B-9925-22365A075C15" target="_blank">Quality Hotel Arlanda
            XPO Direkt</a>
          </li>
        </ul><br>
        <b>Components to be released:</b>
        <ul>
          <li>
            <a href="/parkifly/tui" target="_blank">parkifly/tui</a> |
            <a href="/parkifly/nazar" target="_blank">parkifly/nazar</a>
          </li>
        </ul><br>
        <b>Components to be removed:</b>
        <ul>
          <li><a href="/parkifly/flygets" target="_blank" class="strikethrough-link">parkifly/flygets</a> |
          <a href="/parkifly/skavsta" target="_blank" class="strikethrough-link">parkifly/skavsta</a>
          |
          <a href="/parkifly/handle-booking" target="_blank" class="strikethrough-link">parkifly/handle-booking</a>
        </li>
      </ul><br>
      <b>Displays Test:</b>
      <ul>
        <li>
          <a href="https://parking-display-test.mangocliff-b7a35cda.swedencentral.azurecontainerapps.io/?id=922CFD25-5617-40B5-8F1D-F635029975E9"
          target="_blank">Display Test p1 Gate 51</a> |
          <a href="https://parking-display-test.mangocliff-b7a35cda.swedencentral.azurecontainerapps.io/?id=3E487F75-4069-44E0-9211-6450FCFCFE9D"
          target="_blank">Display Test P3 Gate 91</a> |
          <a href="https://parking-display.blackmoss-70f082ae.swedencentral.azurecontainerapps.io/?id=922CFD25-5617-40B5-8F1D-F635029975E9"
          target="_blank">Display Prod P1 Gate 51</a> |
          <a href="https://parking-display.blackmoss-70f082ae.swedencentral.azurecontainerapps.io/?id=3E487F75-4069-44E0-9211-6450FCFCFE9D"
          target="_blank">Display Prod P3 Gate 91</a> |
          <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayEntry1"
          target="_blank">TestDisplayEntry1 P1</a> |
          <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayEntry2"
          target="_blank">TestDisplayEntry2 P1</a> |
          <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayExit1"
          target="_blank">TestDisplayExit1 P1</a> |
          <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayRegister?gateId=6EE51A97-EF80-4EC3-8E3E-893AF0B9F83F"
          target="_blank">TestDisplayRegister P1</a> |
          <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayRegistered"
          target="_blank">TestDisplayRegistered P1</a> |
          <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayDriveUpRegistered"
          target="_blank">TestDisplayDriveUpRegistered P1</a> |
          <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayParkingFull"
          target="_blank">TestDisplayParkingFull P1</a> |
          <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayLicensePlateNotRead"
          target="_blank">TestDisplayLicensePlateNotRead P1</a> |
          <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayOnEntrySubscription"
          target="_blank">TestDisplayOnEntrySubscription P1</a> |
          <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayOnExitSubscription"
          target="_blank">TestDisplayOnExitSubscription P1</a> |
          <a href="{{hostPath}}Shuttlebuss/Shuttlebuss.Service/LPR/TestDisplayWrongParkingSite"
          target="_blank">TestDisplayWrongParkingSite P1</a> |
        </li>
      </ul><br>
    </div>
    <mat-action-list>
      @if (authService.isCompanyAdmin('Shuttlebuss') || authService.isSiteAdmin() || authService.isDriver('Flygets.se') || authService.isStaff('Skavsta')) {
        <div mat-list-item routerLink="/dashboard" class="display-flex"
          >
          <mat-icon class="mr-2">dashboard</mat-icon>{{'LOGIN.GO_TO_DASHBOARD' | transloco}}
        </div>
      }
    </mat-action-list>
  </mat-card-content>
</mat-card>
}
</div>
</mat-tab>
}

</mat-tab-group>